import { ActionCards, CardType } from '../types';
import { PKG_NAME } from './store';

export const UPDATE_ERROR_MESSAGE_ID = `${PKG_NAME}/UPDATE_ERROR_MESSAGE_ID`;
export const OPEN_ACTION_CARD = `${PKG_NAME}/OPEN_ACTION_CARD`;
export const CLOSE_ACTION_CARD = `${PKG_NAME}/CLOSE_ACTION_CARD`;
export const UPDATE_ACTION_CARDS = `${PKG_NAME}/UPDATE_ACTION_CARDS`;

export const updateErrorMsgId = (errorMsgId: string) => ({
  type: UPDATE_ERROR_MESSAGE_ID,
  payload: errorMsgId,
});

export const openActionCard = (type: CardType) => ({
  type: OPEN_ACTION_CARD,
  payload: type,
});

export const closeActionCard = () => ({
  type: CLOSE_ACTION_CARD,
});

export const updateActionCards = (payload: ActionCards) => ({
  type: UPDATE_ACTION_CARDS,
  payload,
});
